/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateUserRequest
 */
export interface UpdateUserRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateUserRequest
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    account: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    role: UpdateUserRequestRoleEnum;
}

/**
* @export
* @enum {string}
*/
export enum UpdateUserRequestRoleEnum {
    Aao = 'aao',
    Approve = 'approve',
    Office = 'office'
}

export function UpdateUserRequestFromJSON(json: any): UpdateUserRequest {
    return UpdateUserRequestFromJSONTyped(json, false);
}

export function UpdateUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'account': json['account'],
        'name': json['name'],
        'email': json['email'],
        'role': json['role'],
    };
}

export function UpdateUserRequestToJSON(value?: UpdateUserRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'account': value.account,
        'name': value.name,
        'email': value.email,
        'role': value.role,
    };
}


